import { createSelector } from 'reselect';

export const channelsSelector = createSelector(
  (state) => state.d_channels,
  (channels) => channels
);
